import { HelpButton } from '@components/help/HelpButton'
import Page from '@components/Page/Page'
import VenueTag from '@components/venueTag/VenueTag'
import { TableUrlParams, useTableUrlSync } from '@hooks/useTableUrlSync'
import { VenueTag as VenueTagModel } from '@models/VenueTag'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  getVenueTags,
  selectVenueTags,
  setVenueTagQuery,
} from '@store/VenueTagReducer'
import { SBTable, TableParams } from '@supplement-bacon/sb-table-filters'
import { SBRM, SBRMAction, useSBRM } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { Permission } from '@utils/permissions'
import type { TableColumnsType } from 'antd'
import { Space } from 'antd'
import { useEffect } from 'react'

const VenueTagsPage = () => {
  const dispatch = useAppDispatch()
  const venueTags = useAppSelector(selectVenueTags())
  const { query, isLoading } = useAppSelector((state) => state.venueTag)
  const { isOpen } = useSBRM()

  const columns: TableColumnsType<VenueTagModel> = [
    {
      title: 'Tags',
      render: (record: VenueTagModel) => <VenueTag.Avatar model={record} />,
    },
    {
      align: 'right',
      render: (record: VenueTagModel) => (
        <SBRM.Actions
          actions={[SBRMAction.Update, SBRMAction.Delete]}
          entity={Entity.venueTag}
          entityId={record.id}
        />
      ),
    },
  ]

  const fetchVenueTags = (params: TableUrlParams) => {
    const newQuery: TableParams = {
      ...query,
      pagination: {
        ...query.pagination,
        current: params.page,
        pageSize: params.pageSize,
      },
    }
    dispatch(setVenueTagQuery(newQuery))
    dispatch(getVenueTags(newQuery))
  }

  const { handleTableChange, params } = useTableUrlSync<VenueTagModel>({
    onParamsChange: fetchVenueTags,
  })

  useEffect(() => {
    if (isOpen) return

    fetchVenueTags(params)
  }, [isOpen])

  return (
    <Page
      permissions={Permission.listTag}
      pageTitle={{
        title: 'Tags List',
        level: 4,
        toolbar: (
          <Space>
            <HelpButton articleId="79" />
            <SBRM.Actions
              actions={[SBRMAction.Create]}
              entity={Entity.venueTag}
            />
          </Space>
        ),
      }}
    >
      <SBTable
        columns={columns}
        dataSource={venueTags}
        loading={isLoading}
        onChange={handleTableChange}
        pagination={query.pagination}
        showSorterTooltip={{ target: 'sorter-icon' }}
      />
    </Page>
  )
}

export default VenueTagsPage
